import type { IMetadata } from '../interfaces/metadata';

export const SEO: Partial<IMetadata> = {
  title: 'Партнёрская программа Сравни.ру',
  description: 'Лучше страховые и финансовые офферы для монетизации трафика.',
};
